import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import PatientsFilter from '../../../../components/PatientsFilter';
import { REQUEST, ROLES } from '../../../../constants';
import Context from './Context';

const gridSize = PropTypes.shape({
  xs: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  sm: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  md: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  lg: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  xl: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
});

const RequestFilters = ({ withAssignmentFilter, fieldSizes }) => {
  const { search, values, userRole } = useContext(Context);
  const handleChange = (value, name) => search(name, value);
  const excludeRequests = userRole === ROLES.labPartner ? [REQUEST.RETAINER] : [];
  return (
    <PatientsFilter
      handleChange={handleChange}
      filterValues={values}
      withAssignmentFilter={withAssignmentFilter}
      fieldSizes={fieldSizes}
      excludeRequests={excludeRequests}
    />
  );
};

RequestFilters.propTypes = {
  withAssignmentFilter: PropTypes.bool,
  fieldSizes: PropTypes.shape({
    request: gridSize,
    status: gridSize,
    assignment: gridSize,
    steps: gridSize
  })
};

RequestFilters.defaultProps = {
  withAssignmentFilter: true,
  fieldSizes: null
};

export default RequestFilters;
